export default __webpack_public_path__ + "static/Logo-bee01c4f518c02e56017919b55d13056.svg";